import { ImagesSlider } from 'components/ImagesSlider/ImagesSlider';
import { BodyText, OtherText } from 'styling/Typography';
import { GLDetailsCard, GLDetailsCardContainer, GLDetailsStartEnd } from '../GlobalView.styled';
import { WidgetHeader, WidgetTitle, WidgetDetailsLink } from 'pages/HrDashboard/Widgets/widgetParts.styled';
import { ColoredDot, Flex, P } from 'styling/GlobalStyles';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import { MachineDonut } from './MachineDonut';
import { DBIndicator } from 'pages/Dashboard/DashboardMachines/DBMachines.styled';
import { formatDateForDisplay, getTimeFromDate, minsToHrMin } from 'utils/helpers';
import { DBTimelineLogContainer, TimelineLineContainer, TimelineLog } from 'pages/Dashboard/DashboardTasks/DBTasks.styled';
import { useNavigate } from 'react-router-dom';
import { taskStatusesData } from 'pages/Dashboard/dashboardData';
import { ISelectedPin } from 'types/global-view.interface';
import { IMachineTrip } from 'types/api/globalViewApi.interface';
import { Spinner } from 'components/Loading/Loading';
import { tokens } from 'styling/tokens';

export const MachineDetails = ({ map, openedPin, setSelectedPins }: { map: any, openedPin: ISelectedPin, setSelectedPins: React.Dispatch<SetStateAction<ISelectedPin[]>> }) => {
    const { machineHistory, machineInfo, machinesLoading } = useSelector((state: RootState) => state.globalView)
    const historyRef = useRef(null)
    const vehicle = machineInfo?.frotcomVehicle ? 'frotcomVehicle' : 'develonVehicle'
    const navigate = useNavigate()
    const [imagesModal, setImagesModal] = useState({ open: false, images: [], details: '' })

    const handleImages = (images: string[], details: string) => {
        setImagesModal(prev => {
            const copy = structuredClone(prev)
            copy.images = images
            copy.details = details
            copy.open = true
            return copy
        })
    }


    useEffect(() => {
        if (map && machineHistory?.locations.length) {
            historyRef.current = new google.maps.Polyline({
                path: machineHistory.locations.map(l => ({ lat: l.latitude, lng: l.longitude })),
                geodesic: true,
                strokeColor: tokens.accent.base,
                strokeOpacity: 1.0,
                strokeWeight: 2,
            });

            historyRef.current.setMap(map);
        }
    }, [map, machineHistory]);

    const handleTrips = () => {

        setSelectedPins(prev => prev.map(p => {
            if (p.id == openedPin.id) {
                return { ...p, showTrips: true }
            } else {
                return p
            }
        }))
    }


    return <GLDetailsCardContainer>
        {machinesLoading && <Spinner loading={true} />}

        {machineInfo?.[vehicle] && <GLDetailsCard  >
            <WidgetTitle>Operational hour</WidgetTitle>
            <Flex column center gap='1rem' >
                {/* <Chart notAvailable={!machineInfo?.[vehicle]?.utilization?.utilizationRatePercent} fontSize={12} customLabel={machineInfo?.[vehicle]?.utilization?.utilizationRatePercent + '%'} color={'#25E678'} data={[{ name: 'Working', value: !machineInfo?.[vehicle]?.utilization ? 5 : machineInfo?.[vehicle]?.utilization?.operatingHours }, { name: 'Idle', value: !machineInfo?.[vehicle]?.utilization ? 23 : machineInfo?.[vehicle]?.utilization?.idleHours }]} chartColors={['#25E678', '#DFDEE1']} modifiedData={[{ name: 'Working', value: !machineInfo?.[vehicle]?.utilization ? 5 : machineInfo?.[vehicle]?.utilization?.operatingHours }, { name: 'Idle', value: !machineInfo?.[vehicle]?.utilization ? 23 : machineInfo?.[vehicle]?.utilization?.idleHours }]} /> */}
                <DBIndicator whiteBg green level={machineInfo?.[vehicle]?.utilization?.utilizationRatePercent ?? 60} />
                <Flex center gap='1rem' >
                    <Flex gap='5px' >
                        <Flex mt='1rem' gap='1rem' center >
                            <ColoredDot color={tokens.status.success.fg} />
                            <P>Working</P>
                        </Flex>
                        <P>{machineInfo?.[vehicle]?.utilization?.operatingHours ?? '/'} h</P>
                    </Flex>
                    <Flex gap='5px' >
                        <Flex gap='1rem' center >
                            <ColoredDot color={tokens.border.hairline} />
                            <P>Idle</P>
                        </Flex>
                        <P>{machineInfo?.[vehicle]?.utilization?.idleHours ?? '/'} h</P>
                    </Flex>
                </Flex>
            </Flex>
        </GLDetailsCard>}

        {machineInfo?.[vehicle]?.fuelRemainingPercent && <GLDetailsCard  >
            <WidgetTitle>Fuel level</WidgetTitle>
            <Flex center gap='5px'>
                <DBIndicator level={machineInfo?.[vehicle]?.fuelRemainingPercent ?? 60} />
                <OtherText>{machineInfo?.[vehicle]?.fuelRemainingPercent.toFixed(2) ?? 60}%</OtherText>
            </Flex>
        </GLDetailsCard>}

        {machineInfo?.[vehicle] && <GLDetailsCard  >
            <WidgetTitle>Fuel used</WidgetTitle>
            <Flex column center >
                <MachineDonut
                    working={machineInfo?.[vehicle]?.fuelData?.totalAmountForOperatingHours}
                    idle={machineInfo?.[vehicle]?.fuelData?.totalAmountForIdleHours}
                    label={(machineInfo?.[vehicle]?.fuelData?.amountPerHour ?? 0) + ' L/H'}
                    notAvailable={!machineInfo?.[vehicle]?.fuelData?.amountPerHour}
                />

                <Flex center between width='100%' style={{ marginTop: '1rem' }} gap='1rem' >
                    <Flex gap='10px'>
                        <Flex mt='1rem' gap='1rem' center >
                            <ColoredDot color={tokens.accent.base} />
                            <P>Working </P>
                        </Flex>
                        <P>{machineInfo?.[vehicle]?.fuelData?.totalAmountForOperatingHours ?? '/'} h</P>
                    </Flex>
                    <Flex gap='10px'>
                        <Flex gap='1rem' center >
                            <ColoredDot color={tokens.border.hairline} />
                            <P>Idle </P>
                        </Flex>
                        <P>{machineInfo?.[vehicle]?.fuelData?.totalAmountForIdleHours ?? '/'} h</P>
                    </Flex>
                </Flex>
                {machineInfo?.[vehicle]?.averageFuelConsumptionAmount && <Flex mt='16' width='100%' between  >
                    <OtherText weight='' >Average Fuel Consumption</OtherText>
                    <OtherText weight='bold' >{machineInfo?.[vehicle]?.averageFuelConsumptionAmount} L/100KM</OtherText>
                </Flex>}
            </Flex>
        </GLDetailsCard>}
        <GLDetailsCard>
            <WidgetHeader>
                <WidgetTitle>Trips</WidgetTitle>
                <WidgetDetailsLink onClick={handleTrips}>View details ›</WidgetDetailsLink>
            </WidgetHeader>
            <Flex width='100%' column>
                <Flex width='100%' gap='1rem' >
                    <Flex width='100%' between >
                        <OtherText>Distance</OtherText>
                        <OtherText>{summarizeEntries(machineInfo?.trips || [])?.distance?.toFixed(2) || '/'} km</OtherText>
                    </Flex>
                    <Flex width='100%' between >
                        <OtherText>Start</OtherText>
                        <OtherText>{summarizeEntries(machineInfo?.trips || [])?.start || '/'}</OtherText>
                    </Flex>
                </Flex>
                <Flex width='100%' gap='1rem' >
                    <Flex width='100%' between>
                        <OtherText>Duration</OtherText>
                        <OtherText>{minsToHrMin(summarizeEntries(machineInfo?.trips || [])?.duration || 0, true) || '/'}</OtherText>
                    </Flex>
                    <Flex width='100%' between >
                        <OtherText>End</OtherText>
                        <OtherText>{summarizeEntries(machineInfo?.trips || [])?.end || '/'}</OtherText>
                    </Flex>
                </Flex>
            </Flex>
        </GLDetailsCard>
        <GLDetailsCard>
            <WidgetTitle>Current task</WidgetTitle>
            <BodyText  >{machineInfo?.currentUserTask?.taskName || 'No current task'}</BodyText>
            {machineInfo?.currentUserTask && <><GLDetailsStartEnd>
                <div>
                    <OtherText >Estimated Start Date</OtherText>
                    <OtherText weight='bold'>{machineInfo?.currentUserTask?.estimatedStartDate ? formatDateForDisplay(machineInfo?.currentUserTask?.estimatedStartDate) : '/'}</OtherText>
                </div>
                <div>
                    <OtherText >Estimated End Date</OtherText>
                    <OtherText weight='bold'>{machineInfo?.currentUserTask?.estimatedEndDate ? formatDateForDisplay(machineInfo?.currentUserTask?.estimatedEndDate) : '/'}</OtherText>
                </div>
            </GLDetailsStartEnd>
                <GLDetailsStartEnd>
                    <div>
                        <OtherText>Actual Start Date</OtherText>
                        <OtherText weight='bold'>{machineInfo?.currentUserTask?.actualStartDate ? formatDateForDisplay(machineInfo?.currentUserTask?.actualStartDate) : '/'}</OtherText>
                    </div>
                    <div>
                        <OtherText >Actual End Date</OtherText>
                        <OtherText weight='bold'>{machineInfo?.currentUserTask?.actualEndDate ? formatDateForDisplay(machineInfo?.currentUserTask?.actualEndDate) : '/'}</OtherText>
                    </div>
                </GLDetailsStartEnd>
                <DBTimelineLogContainer open={true} onClick={e => e.stopPropagation()} >
                    <TimelineLineContainer noBorder >
                        {
                            machineInfo?.currentUserTask?.executions.slice(-2).map((e, i) => <TimelineLog key={i} >
                                <p className='time' >{formatDateForDisplay(e.from, true)} <br /> {getTimeFromDate(e.from)}</p>
                                <div className='svg' >
                                    <svg width='30' height='50' xmlns='http://www.w3.org/2000/svg' overflow='visible' >
                                        {!(e.status == 3 || e.status == 7) && <line x1='10' y1='15' x2='10' y2='60' stroke={tokens.accent.base} strokeWidth='3' />}
                                        {i > 0 && <> <circle cx='10' cy='10' r='7' fill={tokens.accent.base} strokeWidth='3' />
                                            <circle cx='10' cy='10' r='3' fill={tokens.text.primary} /></>}
                                        {i == 2 && <> <circle cx='10' cy='55' r='7' fill={tokens.accent.base} strokeWidth='3' />
                                            <circle cx='10' cy='55' r='3' fill={tokens.text.primary} /></>}
                                    </svg>
                                </div>
                                <Flex column >
                                    <p className='task-status' >{taskStatusesData.find(s => s.id == e.status).name} <span style={{ color: tokens.status.danger.fg }} >{e.status == 4 && (e.userTaskExecutionIssue?.issueTrigger?.issue?.name || (e as any).executionIssue?.issueTrigger?.issue?.name)}</span></p>
                                    {((e.status == 3 && e.completedImageUrls.length > 0) || (e.status !== 3 && e.reportedImageUrls.length > 0)) &&
                                        <p className='view-image' onClick={() => handleImages(e.status == 3 ? e.completedImageUrls : e.reportedImageUrls, e.userTaskExecutionIssue?.description)}>View Image</p>}
                                </Flex>
                            </TimelineLog>
                            )
                        }
                    </TimelineLineContainer>
                </DBTimelineLogContainer>
                <Flex width='100%' end='true' >
                    <WidgetDetailsLink onClick={() => navigate('/dashboard/tasks/' + machineInfo?.currentUserTask.id)}>View details ›</WidgetDetailsLink>
                </Flex></>}
        </GLDetailsCard>
        <GLDetailsCard>
            <WidgetTitle>Next task</WidgetTitle>
            <BodyText  >{machineInfo?.nextUserTask?.taskName || 'No next task'}</BodyText>
            {machineInfo?.nextUserTask && <GLDetailsStartEnd>
                <div>
                    <OtherText >Estimated Start Date</OtherText>
                    <OtherText weight='bold'>{machineInfo?.nextUserTask?.estimatedStartDate ? formatDateForDisplay(machineInfo?.nextUserTask?.estimatedStartDate) : '/'}</OtherText>
                </div>
                <div>
                    <OtherText >Estimated End Date</OtherText>
                    <OtherText weight='bold'>{machineInfo?.nextUserTask?.estimatedEndDate ? formatDateForDisplay(machineInfo?.nextUserTask?.estimatedEndDate) : '/'}</OtherText>
                </div>
            </GLDetailsStartEnd>}
        </GLDetailsCard>
        {
            imagesModal.open && (
                <ImagesSlider images={imagesModal.images} setImagesModal={setImagesModal} />
            )
        }
    </GLDetailsCardContainer>
}

type Summary = {
    duration: number // in minutes
    distance: number // in same unit as input
    start: string
    end: string
}

function summarizeEntries(entries: IMachineTrip[]): Summary | null {
    if (entries.length === 0) return null

    // Sort entries by startDate
    const sorted = [...entries].sort((a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
    )

    let totalDurationSeconds = 0
    let totalDistance = 0

    for (const entry of entries) {
        totalDurationSeconds += entry.duration
        totalDistance += entry.distance ?? 0
    }

    const firstStart = new Date(sorted[0].startDate)
    const lastEnd = sorted[sorted.length - 1].endDate
        ? new Date(sorted[sorted.length - 1].endDate!)
        : new Date(firstStart.getTime() + totalDurationSeconds * 1000)

    const sameDay =
        firstStart.toDateString() === lastEnd.toDateString()

    function formatDate(date: Date): string {
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        const time = `${hours}:${minutes}`

        if (!sameDay) {
            const y = date.getFullYear()
            const m = (date.getMonth() + 1).toString().padStart(2, '0')
            const d = date.getDate().toString().padStart(2, '0')
            return `${d}.${m}.${y}. ${time}`
        }

        return time
    }

    return {
        duration: Math.round(totalDurationSeconds / 60),
        distance: totalDistance,
        start: formatDate(firstStart),
        end: formatDate(lastEnd)
    }
}